export const TaskTableItemCommitType = {
  Done: 'done',
  YesNo: 'yesno',
}

export const TaskStatusType = {
  Done: 'done',
  No: 'no',
  Yes: 'yes',
}

export const TaskActivityApiNames = {
  Call1: 'call_1.svg',
  Call2: 'call_2.svg',
  Camera: 'camera.svg',
  Car: 'car.svg',
  Cash: 'cash.svg',
  Chart: 'chart.svg',
  Chimney: 'chimney_sweep.svg',
  Craftsman1: 'craftsman_1.svg',
  Craftsman2: 'craftsman_2.svg',
  Deadline1: 'deadline_1.svg',
  Deadline2: 'deadline_2.svg',
  Deadline3: 'deadline_3.svg',
  Email: 'email.svg',
  Gardening: 'gardening.svg',
  Insuranse: 'Insurance.svg',
  Jourfix: 'jourfix.svg',
  KeyDelivery: 'key_delivery.svg',
  Laptop: 'laptop.svg',
  Location: 'location.svg',
  Meeting1: 'meeting_1.svg',
  Meeting2: 'meeting_2.svg',
  PieChart: 'pie_chart.svg',
  Posting1: 'posting_1.svg',
  Posting2: 'posting_2.svg',
  Print: 'print.svg',
  Reporting1: 'reporting_1.svg',
  Reporting2: 'reporting_2.svg',
  Request: 'request.svg',
  Research1: 'research_1.svg',
  Research2: 'research_2.svg',
  Talk: 'talk.svg',
  Task: 'task.svg',
  Tool: 'tool.svg',
  Tv: 'tv.svg',
  Vacation: 'vacation.svg',
  Work: 'work.svg',
  Writing: 'writing.svg',
}

export const TaskTableCellName = {
  ActivityType: 'activity_type',
  Building: 'building',
  BuildingGroups: 'building_groups',
  Category: 'category',
  ClosedAt: 'closed_at',
  ClosedBy: 'closed_by',
  Contractors: 'contractors',
  Created: 'created',
  CreatedBy: 'created_by',
  Deadline: 'deadline',
  Flat: 'flat',
  Manager: 'manager',
  Phase: 'phase',
  Priority: 'priority',
  Request: 'request',
  RequestOwner: 'request_owner',
  Status: 'status',
  Title: 'title',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
  VisibleToTenant: 'visible_to_tenant',
}
